import styled from 'styled-components'

import { SearchElement } from '@application/Interfaces/Features/SearchElement'
import { Button as ButtonBase } from '@application/Interfaces/Molecules/Button'
import ContainerBase from '@mui/material/Container'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    position: relative;

    ${(props) => props.$mode === 'Light' && `background-color: ${props.theme.color.white};`}
    ${(props) => props.$mode === 'Dark' && props.theme.gradient.wave};
`

export const Container = styled(ContainerBase)<{ $showProfileSection: boolean }>`
    position: relative;
    && {
        padding: 68px 15px 16px;
        max-width: 1170px;

        @media ${(props) => props.theme.query.min.tablet} {
            ${(props) => props.$showProfileSection && `padding: 9vw 15px 8vw 15px;`}
            ${(props) => !props.$showProfileSection && `padding: 158px 15px 104px 15px;`}
        }
    }
`

export const Title = styled.span`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium};
    ${(props) => props.theme.gradient.nector};
    background-clip: text;
    color: transparent;
    margin-bottom: 16px;
    text-transform: uppercase;
`

export const Search = styled(SearchElement)``

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;

    .secondary-button {
        margin-right: 16px;
    }
`

export const Button = styled(ButtonBase)`
    margin-bottom: 16px;
`
